import api from 'api/api'
import { toast } from 'react-toastify'
import { GET_PRODUCT_REQUESTS_SORTED_BY_USER } from './product_requests.actions'

export const GET_ITEMS_BY_SUPPLIER_ORDER_ID = '[SUPPLIER ORDER ITEMS] GET ITEMS BY SUPPLIER ORDER ID'
export const SAVE_SUPPLIER_ORDER_ITEMS = '[SUPPLIER ORDER ITEMS] SAVE SUPPLIER ORDER ITEMS'
export const REMOVE_PRODUCT_REQUEST = '[SUPPLIER ORDER ITEMS] REMOVE PRODUCT REQUEST'
export const REMOVE_SUPPLIER_ORDER_ITEM = '[SUPPLIER ORDER ITEMS] REMOVE SUPPLIER ORDER ITEM'

export function getItemsBySupplierOrderIdAction(supplierOrderId) {
  const request = api.get(`/supplier-order-items/by-supplier-order/${supplierOrderId}`)
  return (dispatch) => {
    dispatch({ type: GET_ITEMS_BY_SUPPLIER_ORDER_ID, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_ITEMS_BY_SUPPLIER_ORDER_ID, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_ITEMS_BY_SUPPLIER_ORDER_ID, error)
    }).finally(() => {
      dispatch({ type: GET_ITEMS_BY_SUPPLIER_ORDER_ID, payload: { loading: false } })
    })
  }
}

export function saveSupplierOrderItemsAction(supplierOrderId, products) {
  const request = api.post(`/supplier-order-items/save/${supplierOrderId}`, products)
  return (dispatch) => {
    dispatch({ type: SAVE_SUPPLIER_ORDER_ITEMS, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_SUPPLIER_ORDER_ITEMS, payload: { saved: true, data: response.data.data } })
      dispatch({ type: GET_PRODUCT_REQUESTS_SORTED_BY_USER, payload: { data: response.data.product_requests } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_SUPPLIER_ORDER_ITEMS, error)
    }).finally(() => {
      dispatch({ type: SAVE_SUPPLIER_ORDER_ITEMS, payload: { saving: false } })
    })
  }
}

export function removeProductRequestAction(productRequestId) {
  const request = api.delete(`/supplier-order-item/remove-product-request/${productRequestId}`)
  return (dispatch) => {
    dispatch({ type: REMOVE_PRODUCT_REQUEST, payload: { removing_id: productRequestId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: REMOVE_PRODUCT_REQUEST, payload: { removed_id: productRequestId } })
      dispatch({ type: GET_PRODUCT_REQUESTS_SORTED_BY_USER, payload: { data: response.data.product_requests } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(REMOVE_PRODUCT_REQUEST, error)
    }).finally(() => {
      dispatch({ type: REMOVE_PRODUCT_REQUEST, payload: { removing_id: productRequestId } })
    })
  }
}

export function removeSupplierOrderItemAction(supplierOrderItemId) {
  const request = api.delete(`/supplier-order-item/remove/${supplierOrderItemId}`)
  return (dispatch) => {
    dispatch({ type: REMOVE_SUPPLIER_ORDER_ITEM, payload: { removing_id: supplierOrderItemId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: REMOVE_SUPPLIER_ORDER_ITEM, payload: { removed_id: supplierOrderItemId } })
      dispatch({ type: GET_PRODUCT_REQUESTS_SORTED_BY_USER, payload: { data: response.data.product_requests } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(REMOVE_SUPPLIER_ORDER_ITEM, error)
    }).finally(() => {
      dispatch({ type: REMOVE_SUPPLIER_ORDER_ITEM, payload: { removing_id: supplierOrderItemId } })
    })
  }
}
